//
import { required } from '@/services/validations'
import ProductAdjustStockModel from '@/models/Warehouse/WhProductAdjustStock'
import StockAdjustTypeModel from '@/models/Warehouse/WhStockAdjustType'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'

//
import ProductFilters from './filters'
import ProductHeaders from './headersProduct'

//
import StockAdjustDetailHeaders from './headers'

//
export default ({
    g_branch_office_id,
    g_branch_office_selected_id,
    triggerWarehouse,
    wh_warehouse_id,
}) => [
    {
        name: 'wh_stock_adjust_type_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            loadingText: 'Cargando tipos de ajuste...',
            model: StockAdjustTypeModel,
            noDataText: 'Sin tipos.',
            noObject: true,
            paramSearch: 'type',
            rules: [required],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            loadingText: 'Cargando bodegas...',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            paramFilter: {
                g_branch_office_id,
            },
            rules: [required],
        },
    },
    {
        name: 'wh_selected_products',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: StockAdjustDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: 'Items',
            pickerProps: {
                filters: ProductFilters({ triggerWarehouse }),
                headers: ProductHeaders,
                noPagination: false,
                mapper: row => {
                    row['g_branch_office_id'] = g_branch_office_selected_id
                    row['quantity'] = 0
                    row['wh_product_id'] = row.id
                    return row
                },
                submitText: 'confirmar selección',
                service: ProductAdjustStockModel,
                attachParams:{wh_warehouse_id: (wh_warehouse_id)}
            },
            rules: [required],
            showNativePagination: true,
            showPicker: (wh_warehouse_id) ? true : false, //ocultar agregar sin no esta seleccionada una bodega.
            style: {
                //margin: "0 -24px"
            },
            toolbarTitle: 'Lista de productos incluidos en el ajuste de stock',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario',
            rules: [required],
        },
    },
]
